export function calculateHPB(selectedIndustry, hba, k, tm, ts, ash) {
    let hpb = 0;

    if (selectedIndustry === 'exp' || selectedIndustry === 'cus') {
        if (k > 6000) {
            hpb = hba.HBA0 * (k / 6322) * ((100 - tm) / (100 - 12.26)) - ((ts - 0.66) * 4 + (ash - 7.94) * 0.4);
        } else if (k > 5299) {
            hpb = hba.HBA1 * (k / 5300) * ((100 - tm) / (100 - 21.32)) - ((ts - 0.75) * 4 + (ash - 6.04) * 0.4);
        } else if (k > 4101) {
            hpb = hba.HBA2 * (k / 4100) * ((100 - tm) / (100 - 35.73)) - ((ts - 0.23) * 4 + (ash - 3.9) * 0.4);
        } else if (k > 3400) {
            const fka = (((100 - 35.73) / (100 - tm)) * tm + (100 - 35.73)) / 100; 
            hpb = hba.HBA2 * (k / 4100) * ((100 - tm) / (100 - (35.73 / fka))) - ((ts - 0.23) * 4 + (ash - 3.9) * 0.4);
        } else {
            const fka = (((100 - 44.30) / (100 - tm)) * tm + (100 - 44.30)) / 100; 
            hpb = hba.HBA3 * (k / 3400) * ((100 - tm) / (100 - (44.30 / fka))) - ((ts - 0.24) * 4 + (ash - 3.88) * 0.4);
        }
    } else if (selectedIndustry === 'cem' || selectedIndustry === 'pln') {
        if (k > 4199) {
            hpb = hba.HBA0 * (k / 6322) * ((100 - tm) / (100 - 8)) - ((ts - 0.8) * 4 + (ash - 15) * 0.4);
        } else {
            hpb = hba.HBA0 * (k / 6322) * ((100 - tm) / (100 - 8 / (((((100 - 8) / (100 - tm)) * tm) + (100 - 8)) / 100))) - ((ts - 0.8) * 4 + (ash - 15) * 0.4);
        }
    } else if (selectedIndustry === 'p40') {
        hpb = hba.HBA0 * (k / 6322) * ((100 - tm) / (100 - 8 / (((((100 - 8) / (100 - tm)) * tm) + (100 - 8)) / 100)));
    }

    return hpb;
}